/* istanbul ignore file */
import { theme } from '@noths/polaris-client-ribbons-base';
import { css } from 'styled-components';

const { spacing } = theme;

export const videoSlide = css`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  /* Black letterbox/pillarbox bars behind the poster and the fading-in player. */
  background-color: #000;
`;

export const poster = css`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

export const player = css`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  /* Hide the player's own controls and let clicks pass through to the slide wrapper. */
  --controls: none;
  pointer-events: none;
  transition: opacity 400ms ease;
`;

export const expandButton = css`
  position: absolute;
  left: ${spacing.md}px;
  bottom: ${spacing.md}px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  padding: 0;
  border: none;
  border-radius: 50%;
  background-color: var(--neutral-white-base);
  color: var(--neutral-black-base);
  font-size: 14px;
  line-height: 1;
  cursor: pointer;
`;
